import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import ODB from "./ODB";
import FiberProvider from "./FiberProvider";
import PersonalityVerification from "./PersonalityVerification";
import {
  addItemsToCart,
  createOrder,
  getProductDetailsBySKU,
} from "../../BackendServices/services";
import { v4 as uuidv4 } from "uuid";
import { Spin } from "antd";

import { isSubmitting, hasSubmitSucceeded, hasSubmitFailed } from "redux-form";
import { connect } from "react-redux";
import ContactInfo from "./ContactInfo";
import { Row } from "antd";
import Thankyou from "./Thankyou";
import WrongScreen from "./WrongScreen";

const errorPage = window.errorPageURL;

function isEmpty(val) {
  if (val === undefined) return true;

  if (
    typeof val == "function" ||
    typeof val == "number" ||
    typeof val == "boolean" ||
    Object.prototype.toString.call(val) === "[object Date]"
  )
    return false;

  if (val == null || val.length === 0)
    // null or 0 length array
    return true;

  if (typeof val == "object") {
    // empty object

    var r = true;

    for (var f in val) r = false;

    return r;
  }

  return false;
}

class WizardForm extends Component {
  constructor(props) {
    super(props);
    this.nextPage = this.nextPage.bind(this);
    this.previousPage = this.previousPage.bind(this);
    this.state = {
      page: 1,
      loading: false,
      latitude: "24.7096",
      longitude: "46.6749",
      productId: 0,
      address: "",
      variationId: 0,
    };
  }
  nextPage = () => {
    this.setState({ page: this.state.page + 1 });
  };

  wrongPage = () => {
    this.setState({ page: this.state.page + 2 });
  };
  previousPage = () => {
    this.setState({ page: this.state.page - 1 });
  };

  backToOne = () => {
    this.setState({ page: 1 });
  };

  getParameter(param) {
    const search = window.location.search;
    const params = new URLSearchParams(search);
    return params.get(param);
  }

  componentDidMount() {
    this.setState({
      loading: true,
    });

    let skuId = window.sessionStorage.sku;

    if (isEmpty(skuId)) {
      skuId = this.getParameter("sku");
    }

    if (skuId) {
      getProductDetailsBySKU(skuId).then((response) => {
        if (response.data && response.data[0]) {
          this.setState({
            productId: response.data[0].parent_id,
            variationId: response.data[0].id,
            loading: false,
          });
        }
      });
    } else {
      document.location.href = errorPage;
    }
  }

  componentWillMount() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          this.setState({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          });
        },
        (err) => console.log(err)
      );
    }
  }

  showResults = (values) => {
    let variationId = this.state.variationId;

    this.addItemsToCartFn(variationId, values);
  };

  addItemsToCartFn(variation_id, values) {
    this.setState({
      loading: true,
    });
    let cart_key = uuidv4();
    addItemsToCart(cart_key, this.state.productId, variation_id)
      .then((response) => {
        if (response.status !== 200 && response.status !== 201) {
          this.wrongPage();
          this.setState({
            loading: false,
          });
          return;
        }

        this.createOrder(cart_key, values);
      })
      .catch((error) => {
        this.wrongPage();
        this.setState({
          loading: false,
        });
      });
  }

  createOrder = (cart_key, values) => {
    const { t } = this.props;

    createOrder(
      cart_key,
      this.state.latitude,
      this.state.longitude,
      this.state.address,
      values
    )
      .then((response) => {
        if (response.status !== 200 && response.status !== 201) {
          this.wrongPage();
          this.setState({
            loading: false,
          });
        } else {
          /*window.sessionStorage.orderNumber = response.data.number;
                window.sessionStorage.cusotmerEmail = response.data.billing.email;
                window.location.href = process.env.REACT_APP_ORDER_STATUS_URL*/
          localStorage.setItem("orderNumber", response.data.number);
          localStorage.setItem("cusotmerEmail", values.email);
          window.sessionStorage.sku = "";
          window.sessionStorage.thanksMessage = t("thank_you_desc");
          window.location.href = window.storeThankYouURL;
        }
      })
      .catch((error) => {
        console.log("create Order response => catch error");

        this.wrongPage();
        this.setState({
          loading: false,
        });
      });
  };

  render() {
    const { onSubmit } = this.props;
    const { page, submitSucceeded } = this.state;

    return (
      <Spin spinning={this.state.loading} size="large">
        <Row style={{ padding: "5rem 0.7rem" }}>
          {page === 1 && <ODB onSubmit={this.nextPage} />}
          {page === 2 && (
            <FiberProvider
              previousPage={this.previousPage}
              onSubmit={this.nextPage}
            />
          )}
          {page === 3 && (
            <PersonalityVerification
              previousPage={this.previousPage}
              onSubmit={this.nextPage}
            />
          )}
          {page === 4 && (
            <ContactInfo
              previousPage={this.previousPage}
              onSubmit={this.showResults}
            />
          )}

          {page === 5 && <Thankyou />}

          {page === 6 && <WrongScreen previousPage={this.backToOne} />}
        </Row>
      </Spin>
    );
  }
}

WizardForm = connect((state) => ({
  submitting: isSubmitting("wizard")(state),
  submitSucceeded: hasSubmitSucceeded("wizard")(state),
  submitFailed: hasSubmitFailed("wizard")(state),
}))(WizardForm);

export default withTranslation()(WizardForm);
